import { initTheme } from "@/utils/theme";

import { IChannelConfigs, IChannelTheme } from "../types";

const theme: IChannelTheme = {};

export default {
  configs: {
    key: "samepage",
    pages: {
      login: {
        bannerImageUrl:
          "https://uploads.ytripos.com/uploaded/FusrBQ0SWqsIKIohQhZP9XRjO3ll/same-page-login-banner.png"
      },
      Index: {
        banners: {
          list: [
            {
              img: "https://uploads.ytripos.com/uploaded/FusrBQ0SWqsIKIohQhZP9XRjO3ll/same-page-login-banner.png"
            }
          ]
        }
      }
    },
    benefitIcons: {
      luxury:
        "https://uploads.ytripos.com/uploaded/FlSO5zroZvSZ0N1eGU3YUWamEiDF/samepage_list_luxury.png?imageView2/2/format/webp/w/240"
    },

    benefitDetailIcons: {
      luxury:
        "https://uploads.ytripos.com/uploaded/FgypGpgZVAfTloCLtdhkS607Un_P/samepage_detail_luxury.png?imageView2/2/format/webp/w/240"
    }
  },
  init() {
    initTheme(theme);
  }
} as IChannelConfigs;
